import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable, from, switchMap } from "rxjs";
import { UserService } from "src/app/services/user.service";
import { environment } from "./../../environments/environment";
import { UserDataService } from "./user-data.service";

@Injectable({
  providedIn: "root",
})
export class DeviceService {
  private urlBase = "";

  constructor(
    private http: HttpClient,
    private userService: UserService,
    private userDataService: UserDataService
  ) {
    this.urlBase = environment.urlNonce + "/api";
    console.log("Url base", this.urlBase)
  }

  //INFORMACIÓN DE DISPOSITIVOS Y ESTABLECIMIENTOS

  getUserDevicesData(user_id: number): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        let options = { headers: header };
        return this.http.get(
          this.urlBase + "/user/devices/user_id=" + user_id,
          options
        );
      })
    );
  }

  getDevicesData(dev_reference: string): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        let options = { headers: header };
        return this.http.get(
          this.urlBase + "/deviceReader/obtain/devices=" + dev_reference,
          options
        );
      })
    );
  }

  getDeviceDataNew(dev_reference: number): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let url = this.urlBase + "/device?id=";
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        let options = { headers: header };
        return this.http.get(url + dev_reference, options);
      })
    );
  }

  getDevicesDataNew(): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let url = this.urlBase + "/devices";
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        let options = { headers: header };
        return this.http.get(url, options);
      })
    );
  }

  getDevicesAllData(user_id: number): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        let options = { headers: header };
        return this.http.get(
          this.urlBase + "/user/establishment/user_id=" + user_id,
          options
        );
      })
    );
  }

  getEstablishmentDataNew(estId: number): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let url = this.urlBase + "/establishment?establishment_id=";
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        let options = { headers: header };
        return this.http.get(url + estId, options);
      })
    );
  }

  getDevicesAllDataNew(): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let url = this.urlBase + "/establishments";
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        let options = { headers: header };
        return this.http.get(url, options);
      })
    );
  }

  //DISPOSITIVOS

  createDevice(device: any): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let url = this.urlBase + "/device/create";
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        const options = { headers: header };
        return this.http.post(url, device, options);
      })
    );
  }

  updateDevice(device: any): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let url = this.urlBase + "/device/update";
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        const options = { headers: header };
        return this.http.patch(url, device, options);
      })
    );
  }

  //HISTORICOS

  getDeviceTodayHisrotic(
    dev_reference: string,
    start: string
  ): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        let options = { headers: header };
        return this.http.get(
          this.urlBase +
            "/deviceReader/obtain/device=" +
            dev_reference +
            "&start=" +
            start +
            "&timescale=5",
          options
        );
      })
    );
  }

  getDeviceTodayHisroticTimescale(
    dev_reference: string,
    start: string,
    timescale: string
  ): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        let options = { headers: header };
        return this.http.get(
          this.urlBase +
            "/deviceReader/obtain/device=" +
            dev_reference +
            "&start=" +
            start +
            "&timescale=" +
            timescale,
          options
        );
      })
    );
  }

  getDeviceHisroticDateTimescale(
    dev_reference: string,
    start: string,
    end: string,
    timescale: string
  ): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        let options = { headers: header };
        return this.http.get(
          this.urlBase +
            "/deviceReader/obtain/device=" +
            dev_reference +
            "&start=" +
            start +
            "&end=" +
            end +
            "&timescale=" +
            timescale,
          options
        );
      })
    );
  }

  getLastHisrotic(dev_reference: string): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        let options = { headers: header };
        return this.http.get(
          this.urlBase + "/deviceReader/obtain/device=" + dev_reference,
          options
        );
      })
    );
  }

  getMultiHistoric(
    dev_references: string,
    start: string,
    end: string,
    timescale: string
  ): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        let options = { headers: header };
        return this.http.get(
          this.urlBase +
            "/deviceReader/multi?devices=" +
            dev_references +
            "&start=" +
            start +
            "&end=" +
            end +
            "&scale=" +
            timescale,
          options
        );
      })
    );
  }

  getMultiHistoricNoScale(
    dev_references: string,
    start: string,
    end: string
  ): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        let options = { headers: header };
        return this.http.get(
          this.urlBase +
            "/deviceReader/multi?devices=" +
            dev_references +
            "&start=" +
            start +
            "&end=" +
            end,
          options
        );
      })
    );
  }

  getMultiHistoricRaw(
    dev_references: string,
    start: string,
    end: string,
    timescale: string
  ): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        let options = { headers: header };
        return this.http.get(
          this.urlBase +
            "/deviceReader/multi/raw?devices=" +
            dev_references +
            "&start=" +
            start +
            "&end=" +
            end +
            "&timescale=" +
            timescale,
          options
        );
      })
    );
  }

  //CONSUMOS

  getEstConsumos(est: any): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        let options = { headers: header };
        const start = est.get("start");
        const end = est.get("end");
        const establecimientos = est.get("paises");
        const desglose = est.get("desglose");
        /*console.log(`Start: ${start}`);
          console.log(`End: ${end}`);
          console.log(`Establecimiento: ${establecimientos}`);
          console.log(`Desglose: ${desglose}`);*/
        return this.http.post(this.urlBase + "/reports/consume", est, options);
      })
    );
  }

  //ALARMAS

  getDeviceAlarms(dev_reference: string): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        let options = { headers: header };
        return this.http.post(
          this.urlBase + "/device/alarmas/device=" + dev_reference,
          options
        );
      })
    );
  }

  getEstablishmentAlarms(establishmentId: string): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        let options = { headers: header };
        return this.http.get(
          this.urlBase +
            "/establishment/alarmas/establishment_id=" +
            establishmentId,
          options
        );
      })
    );
  }

  getEstablishmentAlarmsNEW(establishmentData: any): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let url = this.urlBase + "/establishment/alarmas";
        let header = new HttpHeaders({
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${token}`,
        });
        const params = this.formDataToParams(establishmentData);
        const fullUrl = `${url}?${params.toString()}`;
        const options = { headers: header };
        return this.http.get(fullUrl, options);
      })
    );
  }

  private formDataToParams(formData: FormData): HttpParams {
    let params = new HttpParams();
    formData.forEach((value, key) => {
      params = params.append(key, value.toString());
    });
    return params;
  }

  alarmasMasivas(alarmsData: any): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let url = this.urlBase + "/tanks/masive/alarms";
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        const options = { headers: header };
        return this.http.post(url, alarmsData, options);
      })
    );
  }

  getAlarmasEstablecimientos(
    establecimientos: any,
    page: number = 1,
    perPage: number = 20,
    sortField: string = "",
    sortOrder: string = "",
    searchFilter: string = "",
    alarmMode: number = 0,
    isExport: number = 0
  ): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let url =
          this.urlBase +
          "/establishments/alarms?page=" +
          page +
          "&per_page=" +
          perPage +
          "&sort_field=" +
          sortField +
          "&sort_order=" +
          sortOrder +
          "&search=" +
          searchFilter +
          "&alarm_mode=" +
          alarmMode +
          "&export=" +
          isExport;
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        const options = { headers: header };
        return this.http.post(url, establecimientos, options);
      })
    );
  }

  getAlarmasDevices(dispositivos: any): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let url = this.urlBase + "/devices/alarms";
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        const options = { headers: header };
        return this.http.post(url, dispositivos, options);
      })
    );
  }

  //TIPO DE CERVEZA

  createBeerType(beer: any): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let url = this.urlBase + "/beertype/create";
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        const options = { headers: header };
        return this.http.post(url, beer, options);
      })
    );
  }

  editBeerType(beer: any): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let url = this.urlBase + "/beertype/update";
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        const options = { headers: header };
        return this.http.post(url, beer, options);
      })
    );
  }

  getOneBeerType(beertype: number): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        let options = { headers: header };
        return this.http.get(
          this.urlBase + "/beertype?id=" + beertype,
          options
        );
      })
    );
  }

  getBeerType(): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        let options = { headers: header };
        return this.http.get(this.urlBase + "/beertypes", options);
      })
    );
  }

  //CREAR Y EDITAR ESTABLECIMIENTO

  createEstablishment(device: any): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let url = this.urlBase + "/establishment/create";
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        const options = { headers: header };
        return this.http.post(url, device, options);
      })
    );
  }

  updateEstablishment(device: any): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let url = this.urlBase + "/establishment/update";
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        const options = { headers: header };
        return this.http.post(url, device, options);
      })
    );
  }

  //TANQUES

  getTanks(): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        let options = { headers: header };
        return this.http.get(this.urlBase + "/tanks", options);
      })
    );
  }

  createTank(tank: any): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let url = this.urlBase + "/tank/create";
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        const options = { headers: header };
        return this.http.post(url, tank, options);
      })
    );
  }

  editTank(tank: any): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let url = this.urlBase + "/tank/update";
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        const options = { headers: header };
        return this.http.post(url, tank, options);
      })
    );
  }

  getRecargas(establecimientosId: any): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let url = this.urlBase + "/tanks/charges";
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        const options = { headers: header };
        return this.http.post(url, establecimientosId, options);
      })
    );
  }

  //BUSQUEDA DE FILTROS

  crearBusquedaConFiltros(busqueda: any): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let url = this.urlBase + "/reports/consume/filter";
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        const options = { headers: header };
        return this.http.post(url, busqueda, options);
      })
    );
  }

  getBusquedaConFiltros(): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let url = this.urlBase + "/reports/consume/filters";
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        const options = { headers: header };
        return this.http.get(url, options);
      })
    );
  }

  eliminarBusquedaConFiltros(busqueda: any): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let url = this.urlBase + "/reports/consume/filter";
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        const options = { headers: header };
        return this.http.post(url, busqueda, options);
      })
    );
  }

  //PEDIDOS

  getPedidos(start: any, end: any): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let url =
          this.urlBase +
          "/establishment/recharge/orders?from=" +
          start +
          "&to=" +
          end;
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        const options = { headers: header };
        return this.http.get(url, options);
      })
    );
  }

  createPedido(pedido: any): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let url = this.urlBase + "/establishment/recharge/order";
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        const options = { headers: header };
        return this.http.post(url, pedido, options);
      })
    );
  }

  getRitmosConsumo(): Observable<any> {
    return from(this.userService.getLocalSessionToken()).pipe(
      switchMap((token) => {
        let url = this.urlBase + "/reports/consume/rate";
        let header = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        const options = { headers: header };
        return this.http.get(url, options);
      })
    );
  }

  //FUNCIONES COMPLEMENTARIAS

  soloDosDecimalesConComa(numero: number) {
    if (Number.isNaN(numero)) {
      return 0;
    } else {
      return numero.toLocaleString(this.userDataService.getUserData().region, {
        maximumFractionDigits: 2,
      });
    }
  }

  devolverValorAlarma(
    tipoAlarma: string,
    lastReaderJson: any,
    tankJson: any
  ): any {
    let field: any = "";
    switch (tipoAlarma) {
      // NIVEL
      case "L1":
        field = `${this.soloDosDecimalesConComa(
          (lastReaderJson.field17 * 100) / tankJson.capacity
        )} % = ${this.soloDosDecimalesConComa(lastReaderJson.field17)} litros`;
        break;
      case "L2":
        field = `${this.soloDosDecimalesConComa(
          (lastReaderJson.field18 * 100) / tankJson.capacity
        )} % = ${this.soloDosDecimalesConComa(lastReaderJson.field18)} litros`;
        break;
      case "L3":
        field = `${this.soloDosDecimalesConComa(
          (lastReaderJson.field19 * 100) / tankJson.capacity
        )} % = ${this.soloDosDecimalesConComa(lastReaderJson.field19)} litros`;
        break;
      case "L4":
        field = `${this.soloDosDecimalesConComa(
          (lastReaderJson.field25 * 100) / tankJson.capacity
        )} % = ${this.soloDosDecimalesConComa(lastReaderJson.field25)} litros`;
        break;
      // TEMPERATURA MINIMA Y MAXIMA
      case "A1":
      case "B1":
        field = this.soloDosDecimalesConComa(lastReaderJson.field6) + " ºC";
        break;
      case "A2":
      case "B2":
        field = this.soloDosDecimalesConComa(lastReaderJson.field7) + " ºC";
        break;
      case "A3":
      case "B3":
        field = this.soloDosDecimalesConComa(lastReaderJson.field8) + " ºC";
        break;
      case "A4":
      case "B4":
        field = this.soloDosDecimalesConComa(lastReaderJson.field24) + " ºC";
        break;
      // PRESION MINIMA Y MAXIMA
      case "C1":
      case "D1":
        field = this.soloDosDecimalesConComa(lastReaderJson.field3) + " bares";
        break;
      case "C2":
      case "D2":
        field = this.soloDosDecimalesConComa(lastReaderJson.field4) + " bares";
        break;
      case "C3":
      case "D3":
        field = this.soloDosDecimalesConComa(lastReaderJson.field5) + " bares";
        break;
      case "C4":
      case "D4":
        field = this.soloDosDecimalesConComa(lastReaderJson.field23) + " bares";
        break;
      default:
        field = "--";
        break;
    }
    return field;
  }
}
